import React from "react";
import { withRouter, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const GoogleAnalytics = () => {
    const location = useLocation();

    React.useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: location.pathname });


        if (location.pathname.startsWith("/inspection")) {
            const x = location.pathname.split("/inspection");

            if (x.length > 1) {
                const y = x[1].split("/");

                ReactGA.set({ inspectionId: y[1] });

                if (y.length > 2) {
                    ReactGA.event({
                        category: "Navigation",
                        action: y[2],
                        label: y[1],
                        value: 0
                    });
                } else {
                    ReactGA.event({
                        category: "Navigation",
                        action: "visit",
                        label: y[1],
                        value: 0
                    });
                }
            }
        }
    }, [location]);

    return <div />;
};

export default withRouter(GoogleAnalytics);
